import React from "react";
import SectionLabel from "./brand/SectionLabel";

const GALLERY = [
  {
    id: "tower-01",
    category: "TOWER BUILDS",
    title: "Acreage Tower Build",
    location: "Barnwell, AB",
    img: "/brand/acreage-tower.jpg?v=6",
  },
  {
    id: "ptp-01",
    category: "PtP / PtMP",
    title: "Multi-Site Solar Backhaul",
    location: "Burdett, AB",
    img: "/brand/solar-backhaul.jpg",
  },
  {
    id: "unifi-01",
    category: "UNIFI NETWORK",
    title: "Business Network Rebuild",
    location: "Hillspring, AB",
    img: "/brand/business-network.jpg",
  },
  {
    id: "das-01",
    category: "DAS / ENTERPRISE",
    title: "Commercial DAS Deployment",
    location: "Standoff, AB",
    img: "/brand/commercial-das.jpg",
  },
  {
    id: "solar-01",
    category: "SOLAR COMMS",
    title: "Solar Farm SCADA Link",
    location: "Bow Island, AB",
    img: "/brand/scada-link.jpg?v=2",
  },
  {
    id: "unifi-02",
    category: "UNIFI NETWORK",
    title: "Home Full WiFi Overhaul",
    location: "Magrath, AB",
    img: "/brand/home-wifi.jpg",
  },
  {
    id: "booster-01",
    category: "CELL BOOSTER",
    title: "Acreage Cell Booster Install",
    location: "Wrentham, AB",
    img: "/brand/surecall-booster.jpg",
  },
  {
    id: "security-01",
    category: "SECURITY & ACCESS CONTROL",
    title: "Campground Security Networking",
    location: "Glenwood, AB",
    img: "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?auto=format&fit=crop&w=1400&q=80",
  },
];

export default function Gallery() {

  return (
    <section
      id="projects"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-bg-secondary border-t border-steel-dark"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-6">
            <SectionLabel className="mb-5">Field Log</SectionLabel>
            <h2 className="heading text-4xl md:text-5xl lg:text-6xl text-white uppercase leading-[0.95]">
              Built in the <br />
              <span className="text-signal">Field.</span>
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-steel-light text-base md:text-lg leading-relaxed">
              A sampling of real jobs completed across Southern Alberta — tower
              builds, wireless backhaul, network deployments, and DAS
              installations. More projects available on request.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[1px] bg-steel-dark border border-steel-dark">
          {GALLERY.map((item) => (
            <article
              key={item.id}
              data-testid={`gallery-card-${item.id}`}
              className="group relative aspect-[4/3] overflow-hidden bg-bg-primary cursor-pointer"
            >
              <img
                src={item.img}
                alt={item.title}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-bg-primary via-bg-primary/30 to-transparent" />
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-signal transition-all" />

              <div className="relative h-full flex flex-col justify-end p-6">
                <div className="font-mono text-[10px] tracking-[0.25em] text-signal uppercase mb-2">
                  {item.category}
                </div>
                <div className="heading text-xl md:text-2xl text-white uppercase leading-tight mb-1">
                  {item.title}
                </div>
                <div className="font-mono text-xs text-steel-light">
                  {item.location}
                </div>
              </div>

              {/* top-right index */}
              <div className="absolute top-4 right-4 font-mono text-[10px] tracking-[0.25em] text-white/40">
                / {item.id.toUpperCase()}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
